import { useCallback, useState } from 'react';
import { renderBillImage, type BillImageInput } from '@/lib/billImage';
import { saveFile } from '@/lib/saveFile';

interface SaveBill {
  save: (input: BillImageInput) => void;
  busy: boolean;
  /** Lao, safe to show. */
  error: string | null;
  dismiss: () => void;
}

/**
 * Turns a bill into a PNG and hands it to the phone.
 *
 * Not a money action — nothing is written and nothing can be lost — but it
 * still reports failure in Lao, because the alternative is a shopkeeper
 * hunting through their gallery for a picture that was never saved.
 */
export function useSaveBill(): SaveBill {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const save = useCallback(
    (input: BillImageInput) => {
      if (busy) return;
      setBusy(true);
      setError(null);

      void (async () => {
        try {
          const blob = await renderBillImage(input);
          const saved = await saveFile(blob, `bill-${input.invoiceNo}.png`);
          if (!saved) setError('ບັນທຶກຮູບບໍ່ໄດ້ · ລອງກົດ ພິມ ແທນ');
        } catch (cause) {
          setError('ສ້າງຮູບໃບບິນບໍ່ໄດ້ · ລອງກົດ ພິມ ແທນ');
          console.error('bill image failed', cause);
        } finally {
          setBusy(false);
        }
      })();
    },
    [busy],
  );

  return { save, busy, error, dismiss: () => setError(null) };
}
